import React from "react";
import { UrlModalContext } from "./UrlModalContext";
import { useUrlModal } from "@/hooks/useUrlModal";
import { UrlModal } from "@/components/shared/UrlModal";

interface UrlModalProviderProps {
    children: React.ReactNode;
}

export const UrlModalProvider: React.FC<UrlModalProviderProps> = ({ children }) => {
    const urlModal = useUrlModal();

    return (
        <UrlModalContext.Provider value={urlModal}>
            {children}
            <UrlModal
                isOpen={urlModal.isOpen}
                onClose={urlModal.close}
                modalType={urlModal.params.open}
                resource={urlModal.params.resource}
            />
        </UrlModalContext.Provider>
    );
};
